/**
 * Created by logan on August 23, 2016.
 */
var app = (function () {
    'use strict';

    var s;
    return {
        settings: {
            document: $(document),
            pathname: window.location.pathname,
            html: $('html')
        },

        init: function () {
            s = this.settings;

            // RUN ALWAYS
            this.initVideo();
            this.initSplashAnimation();
            this.removeAutoFocus();
            this.initDownArrowScroll();

            // Parse Segments
            var segmentArray = s.pathname.replace(/(^\/)|(\/$)/g, '').split('/');
            s['segment_1'] = segmentArray[0];
            s['segment_2'] = segmentArray[1];

            // Segment Dictated Scripts
            switch (s.segment_1) {
                case "":
                    break;
                case "calendar":
                    break;
            }
        },

        initVideo: function(){
            $('#my-video').backgroundVideo({
                pauseVideoOnViewLoss: false,
                parallaxOptions: {
                    effect: 1.9
                }
            });
        },

        initSplashAnimation: function(){
            $(function(){

                var video = $('#my-video')[0];

                video.addEventListener('playing', function(){ })
            })
        },

        initDownArrowScroll: function () {
            $(".down-icon").on('click', function (event) {

                // prevent default anchor click behavior
                event.preventDefault();

                // store hash
                var hash = this.hash;

                // animate
                $('html, body').animate({
                    scrollTop: $(hash).offset().top
                }, 300);
            });
        },

        removeAutoFocus: function(){
            function show_popup(){
                $('.frame').removeClass('hidden');
            };

            window.setTimeout( show_popup, 2500 ); // 5 seconds
        }
    }
})();

$(function () {
    app.init();
});

//# sourceMappingURL=app.js.map